// Runtime environment configuration loader
// This file handles dynamic environment variables injected by the C# backend

// Declare the global window interface extension
declare global {
  interface Window {
    __RUNTIME_ENVIRONMENT__?: any;
  }
}



/**
 * Gets the runtime environment configuration
 * Uses injected runtime config if available, otherwise falls back to default
 */
export function getRuntimeEnvironment(): any {
  try {
    const runtimeEnv = (window as any).__RUNTIME_ENVIRONMENT__;
    if (runtimeEnv) {
      return runtimeEnv;
    }
    return {};
  } catch (error) {
    console.warn('Failed to load runtime environment, using empty configuration:', error);
    return {};
  }
}

/**
 * Checks if runtime environment is available
 */
export function hasRuntimeEnvironment(): boolean {
  return !!(window as any).__RUNTIME_ENVIRONMENT__;
}

// Export the runtime environment
export const runtimeEnvironment = getRuntimeEnvironment();